var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPostEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0848 2.37974C9.81703 1.64751 11.0042 1.64751 11.7364 2.37974L12.6203 3.26362C13.3526 3.99586 13.3526 5.18304 12.6203 5.91527L6.12502 12.4106C6.03777 12.4978 5.92664 12.5573 5.80565 12.5815L2.49108 13.2444C2.05376 13.3319 1.66818 12.9463 1.75565 12.509L2.41856 9.19443C2.44276 9.07343 2.50223 8.96231 2.58948 8.87506L9.0848 2.37974ZM11.2945 2.82168L12.1784 3.70557C12.6665 4.19372 12.6665 4.98518 12.1784 5.47333L11.0735 6.57819L8.42188 3.92654L9.52674 2.82168C10.0149 2.33353 10.8064 2.33353 11.2945 2.82168ZM7.97994 4.36849L3.03142 9.317L2.36851 12.6316L5.68307 11.9686L10.6316 7.02013L7.97994 4.36849Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostEditIcon);
export default __webpack_public_path__ + "static/media/post-edit-icon.a1993d5558c39b77127425a5f5cb90ba.svg";
export { ForwardRef as ReactComponent };